import React from "react";
import serviceImg from "../../common/images/web-servies.png";
import our from "../../common/images/Our.png";

const HeroSection = () => {
  return (
    <section className="max-w-[1280px] mx-auto md:py-10  px-5 md:px-10 py-5">
      <div className=" flex flex-col lg:flex-row  small:gap-10 gap-5">
        {/* Left Content */}
        <div className="lg:w-1/2 md:text-center text-start lg:text-left">
          <img src={our} alt="Our Img" className="h-20 w-15" />

          <div className="flex items-center gap-5 ">
            <p className="text-black  uppercase tracking-widest font-semibold">
              Services
            </p>

            <p className="h-[3px] w-[30%] bg-webOranage"></p>
          </div>
          <h1 className="text-2xl xs:text-3xl small:text-4xl lg:text-5xl font-bold text-secondary mt-2">
            Build Scalable and{" "}
            <span className="text-primary">High-Performance </span>
            <br /> Websites
          </h1>
          <p className="text-black small:text-md text-sm mt-4 font-semibold ">
            We specialize in creating custom, user-friendly, and responsive
            websites tailored to your business needs. Our team combines
            innovative design with robust technology to deliver websites that
            engage users and drive results.
          </p>
          {/* <button className="small:mt-6 mt-3 px-10 py-2 bg-secondary text-white rounded-lg font-semibold small:text-lg text-sm hover:bg-blue-500 transition-all">
            LET’S TALK
          </button> */}
        </div>
        <div className="lg:w-1/2 bg-gray-50 flex justify-center relative">
          <img
            src={serviceImg}
            alt="Android Development"
            className="w-full max-w-sm md:max-w-md lg:max-w-lg drop-shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
